import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './RentalNode.less';

export class RentalNode extends React.PureComponent {
    static propTypes = {
        fullRowXs: PropTypes.bool,
        icon: PropTypes.string,
        link: PropTypes.string,
        onClick: PropTypes.func,
        orderXs: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string.isRequired,
    };

    render() {
        const classes = classNames(
            ['RentalNode', `RentalNode--${this.props.orderXs}`],
            {
                'RentalNode--full-row-xs': this.props.fullRowXs,
            }
        );

        if (!this.props.text || this.props.text.length <= 0) {
            return null;
        }

        return (
            <div className={classes}>
                <span className="small">{this.props.title}</span>
                {this.props.icon && (
                    <span className="RentalNode__icon hidden-sm hidden-xs">
                        {this.props.icon}
                    </span>
                )}
                {this.props.link ? (
                    <div className="RentalNode-text">
                        <strong>
                            <a
                                onClick={this.props.onClick}
                                href={this.props.link}
                                target="_blank"
                            >
                                {this.props.text}
                            </a>
                        </strong>
                    </div>
                ) : (
                    <div className="RentalNode-text">
                        <strong>{this.props.text}</strong>
                    </div>
                )}
            </div>
        );
    }
}
